/* eslint-disable */
require('./blue_giant')
require('./orange_dwarf')
require('./red_dwarf')
require('./red_giant')
require('./white_dwarf')
require('./yellow_dwarf')
